import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../../../components'
import { Box } from '@mui/material';

const TAETabScreen = () => {
  const navigate = useNavigate();

  return (
    <Box mt={2}>
      <CustomTab
        level={1}
        panels={[
          {
            name: "General",
            route: '/ruteo/panel/tae',
            onChange: () => navigate('../tae'),
            content: <Outlet />
          },
          {
            name: "Excepciones",
            route: '/ruteo/panel/tae/excepciones',
            onChange: () => navigate('excepciones'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default TAETabScreen